import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[row-tmp]",
})
export class RowTmpDirective {
  constructor(private template: TemplateRef<any>) {}
}
